module.exports = __webpack_public_path__ + "assets/img/blindBoxBtn2.36123be1.png";